import { createSlice } from '@reduxjs/toolkit';

import { SlicePayload, UntypedObject } from '@/types';

export type ContactState = UntypedObject;

export const initialState: ContactState = {
};

const contact = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    sendMail: (
      _state,
      _action: SlicePayload<{
        t: (_k: string) => string, form: UntypedObject, host: string, options?: UntypedObject
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    }
  }
});

export const {
  sendMail
} = contact.actions;

export default contact.reducer;
